const sortByYear = (curr: LinkDatum, prev: LinkDatum) => curr.year - prev.year;
const isLongTitle = (linkText: string) => linkText.length > 30;
const isExternalLink = (href: string) => href.startsWith('http');

export {
  isExternalLink,
  isLongTitle,
  sortByYear,
};
